<template>
  <!-- Functions are for admin only -->
  <div v-if="
      $store.state.app.user.indexOf($store.state.auth.uid) > -1 ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.indexOf(
          $store.state.auth.uid
        ) > -1)
  ">
    <div class="flex wrap p4">
      <div class="container p4 flexy">
        <div class="flex column">
          <div class="flex between align-center">
            <!-- clear function creator -->
            <a class="update-text sm-font m8" @click="
                inputs.newfunction
                  ? $delete(inputs, 'newfunction') && $delete(inputs, 'newfunctionid')
                  : $set(
                      inputs,
                      'newfunction',
                      JSON.parse(JSON.stringify(models.function))
                    )
              ">
              <i class="fa fa-plus" />
            </a>
            <a class="update-text xs-font" @click="$set(show, 'import', !show.import)">Import</a>
            <div v-if="show.import">
              <import type="function" :value="$store.state.app.advanced.functions"
                :obj="$store.state.app.advanced.functions" />
            </div>
            <span @click="debug = !debug" class="sm-font">
              <i class="fa fa-bug"></i> {{ debug ? "debug mode" : "" }}
            </span>
            <input type="search" v-model="inputs['search functions']" placeholder="Find function" />
          </div>

          <div class="flex wrap">
            <div class="flex column">
              <!-- Display saved functions -->
              <div v-for="(fn, functionkey) in functions" :key="functionkey" class="flex xs-font">
                <div :class="show['customfunction' + functionkey]
                      ? 'update-border sub-container light-bg'
                      : ''
                  " class="flex column" v-if="
                    !inputs['search functions'] ||
                    JSON.stringify(fn)
                      .toLowerCase()
                      .includes((inputs['search functions'] || '').toLowerCase())
                  ">
                  <span class="m4 flex align-center wrap"><a class="border-bottom flex align-center" @click="
                        $set(counters, fn.name + 'action', 0);
                        $set(
                          show,
                          'customfunction' + functionkey,
                          !show['customfunction' + functionkey]
                        );
                  ">
                      <i class="fa fa-function black-text"></i>
                      <b class="l8 r8 update-text">{{
                        (fn.name || 'Unnamed').toUpperCase()
                      }}</b>
                    </a>
                    <code @click="$copyText(fn.comment)" class="black-text">{{
                      fn.comment
                    }}</code>
                  </span>
                  <div class="flex column p4" v-if="show['customfunction' + functionkey]">
                    <action :key="counters[(fn.name || 'unnamed') + 'action']" :name="fn.name || 'unnamed'" :debug="debug"
                      :fun="functionkey || fn" />
                    <div class="container p4 flex around align-center wrap">
                      <b class="fa fa-edit" @click="
                          inputs.newfunction
                            ? $delete(inputs, 'newfunction')
                            : $set(
                                inputs,
                                'newfunctionid',
                                functionkey
                              ), $set(
                                inputs,
                                'newfunction',
                                JSON.parse(JSON.stringify(fn))
                              )
                        "></b>
                      <rm class="m4" :name="functionkey" :obj="$store.state.app.advanced.functions" :fn="{
                          command: 'dispatch',
                          method: 'update',
                          type: 'app',
                        data: { data: $store.state.app },
                      }" />
                      <!-- displays function model -->
                      <b @click="
                          $set(
                            show,
                            'functionmodel' + functionkey,
                            !show['functionmodel' + functionkey]
                          )
                        ">Model</b>
                      <state class="container indicate-border" v-if="show['functionmodel' + functionkey]" nesting="0"
                        editable="true" :statedata="fn" />
                      <a @click="
                          fn.type = 'function';
                          exportfunction(fn);
                      ">Export</a>
                    </div>
                  </div>
                </div>

                <!-- <code>
                  {{ fn }}
                </code> -->
              </div>
            </div>

            <!-- Create and edit function configurator -->
            <div newfunction v-if="inputs.newfunction" class="p4 flexy sub-container" style="align-self: flex-start">
              <div class="container p8">
                <span class="flex between align-center b8">
                  <span>
                    <b class="update-text md-font r4">{{
                      (
                        inputs["newfunction"].name || "New function "
                      ).toUpperCase()
                    }}</b>
                    <i>config</i>
                  </span>
                  <button class="update m4 p8 sm-font flex align-center flex-end" text="Save" :disabled="!(
                        inputs.newfunction &&
                        inputs.newfunction.name &&
                        inputs.newfunction.commands[0].method
                      )
                    " type="button" @click="
                      // Check for duplicate function names
                      if ($store.state.ref.functions[inputs.newfunction.name] &&
                      $store.state.ref.functions[inputs.newfunction.name] !== inputs.newfunctionid) {
                      alert('Function name ' + inputs.newfunction.name + ' already exists. Please choose a different name.');
                      return;
                    }

                      !$store.state.app.advanced.functions
                        ? ($store.state.app.advanced.functions = {})
                        : null;
                      $store
                        .dispatch('util', {
                          type: 'hash',
                          body: inputs.newfunction,
                        })
                        .then((h) => {
                          $set(
                            $store.state.app.advanced.functions,
                            h,
                            inputs.newfunction
                          );
                          inputs.newfunctionid && h !== inputs.newfunctionid
                            ? $set(
                                $store.state.app.advanced.functions,
                                inputs.newfunctionid, h
                              )
                            : null;
                          $set(inputs, 'newfunctionid', h);
                          $set(show, 'customfunction' + h, true);

                          // Update function reference mapping
                          $set($store.state.ref.functions, inputs.newfunction.name, h);

                          $store
                            .dispatch('update', {
                              type: 'app',
                              data: $store.state.app,
                            })
                            .then(() => {
                              $set(
                                counters,
                                inputs.newfunction.name + 'action',
                                counters[
                                  inputs.newfunction.name + 'action'
                                ] + 1
                              );
                            });
                        });
                      ">
                    <div><i class="fa fa-save" /> Save</div>
                  </button>
                </span>
                <div class="flex between container p8 b8">
                  <label class="flex column align-start">
                    <b class="xs-font">Function Name</b>
                    <input placeholder="Function name" type="text" v-model="inputs.newfunction.name" />
                  </label>
                  <label class="flex column align-start">
                    <b class="xs-font">Function Comment</b>
                    <input type="text" v-model="inputs.newfunction.comment" placeholder="Function comment" />
                  </label>
                </div>

                <div class="flex wrap column fill" v-if="inputs.newfunction">
                  <div class="flex column">
                    <!-- functions take expected inputs, this sets up types. note, in-app set's up their own types
                    TODO: remove input config and automatically add from custom functions like in-app -->
                    <div inputs class="flexy b16">
                      <div class="flex align-center between">
                        <b>Inputs</b>
                      </div>
                      <div class="xs-font update-border container">
                        <div v-for="(input, inputkey) in inputs.newfunction
                          .inputs" :key="inputkey" class="container p4 border-bottom">
                          <div class="flex align-center" v-if="!show['editmodeinput' + inputkey]">
                            <b class="update-text p4">{{ inputkey }}</b>
                            <i class="m4">[ {{ input.type }} ]</i>
                            <rm class="r8" :obj="inputs.newfunction.inputs" :name="inputkey" />
                            <i class="fa fa-edit update-text r4" @click="
                                inputs['editinputname' + inputkey] = inputkey;
                                inputs['editinputtype' + inputkey] = input.type;
                                $set(show, 'editmodeinput' + inputkey, true);
                            " />
                          </div>
                          <div v-else>
                            <div class="flex between align-center">
                              <span>
                                <input type="text" v-model="inputs['editinputname' + inputkey]" />
                                <select v-model="inputs['editinputtype' + inputkey]">
                                  <option disabled>Input Type</option>
                                  <option :selected="opt === input.type" :value="opt" v-for="opt in [
                                      'string',
                                      'number',
                                      'boolean',
                                      'array',
                                      'object',
                                      'function',
                                  ]" :key="opt">
                                    {{ opt }}
                                  </option>
                                </select>
                              </span>
                              <span @click="
                                  $set(
                                    inputs.newfunction.inputs,
                                    inputs['editinputname' + inputkey],
                                    { type: inputs['editinputtype' + inputkey] }
                                  );
                                  inputs['editinputname' + inputkey] !==
                                  inputkey
                                    ? $delete(
                                        inputs.newfunction.inputs,
                                        inputkey
                                      )
                                    : $set(
                                        inputs.newfunction.inputs,
                                        inputkey,
                                        {
                                          type: inputs[
                                            'editinputtype' + inputkey
                                          ],
                                        }
                                      );
                                  inputs['editinputname' + inputkey] = '';
                                  inputs['editinputtype' + inputkey] = '';
                                  $set(show, 'editmodeinput' + inputkey, false);
                              ">
                                <i class="fa fa-lg fa-save update-text" />
                              </span>
                              <rm :name="inputkey" :obj="inputs.newfunction.inputs" />
                            </div>
                          </div>
                        </div>
                        <div v-if="show['newinput']" class="xs-font flex container p8 start wrap update">
                          <div class="flex column r8">
                            <label class="xs-font p4">Input Name</label>
                            <input type="text" placeholder="Input name" v-model="inputs['newinputname']" />
                            <code class="warn p4" v-if="
                                Object.keys(
                                  inputs.newfunction.inputs
                                ).indexOf(inputs['newinputname']) > -1 ||
                                !inputs['newinputname']
                            ">Inputs must have unique names</code>
                          </div>

                          <div>
                            <label class="xs-font">Input Type</label>
                            <select v-model="inputs['newinputtype']" class="m4">
                              <option :value="opt" v-for="opt in [
                                  'string',
                                  'number',
                                  'boolean',
                                  'array',
                                  'object',
                                  'function',
                              ]" :key="opt">
                                {{ opt }}
                              </option>
                            </select>
                          </div>
                          <div>
                            <button v-if="
                                Object.keys(
                                  inputs.newfunction.inputs
                                ).indexOf(inputs['newinputname']) === -1 &&
                                inputs['newinputtype'] &&
                                inputs['newinputname']
                            " type="button" class="update xs-font light-text p4" @click="
                                $set(
                                  inputs.newfunction.inputs,
                                  inputs['newinputname'],
                                  { type: inputs['newinputtype'] }
                                );
                                inputs['newinputname'] = '';
                                inputs['newinputtype'] = '';
                                $set(show, 'newinput', false);
                              ">
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                        <button class="xs-font align-center update-text m4" type="button"
                          @click="$set(show, 'newinput', true)">
                          <i class="fa fa-plus r4" /> Add input
                        </button>
                      </div>
                    </div>

                    <!-- functions are made of a sequence of commands -->
                    <div commands class="">
                      <div class="">
                        <div class="flex align-center between">
                          <b>Commands</b>
                        </div>

                        <!-- commands run in order of operations -->
                        <div class="flex column" v-if="
                            inputs.newfunction &&
                            inputs.newfunction.commands
                        ">
                          <div :class="!command.method && 'warn-border'" class="
                              container
                              b8
                              flex
                              wrap
                              align-center
                              success-border
                            " v-for="(command, commandi) in inputs.newfunction
                              .commands" :key="commandi">
                            <div :class="!command.method && 'warn'" class="
                                xs-font
                                flexy
                                label
                                success
                                fit
                                p8
                                flex
                                wrap
                                align-center
                              ">
                              <i v-if="commandi > 0" @click="
                                  inputs.newfunction.commands.splice(
                                    commandi - 1,
                                    0,
                                    inputs.newfunction.commands.splice(
                                      commandi,
                                      1
                                    )[0]
                                  )
                                " class="fa-arrow-up fa fa-xs"></i>
                              <i class="lg-font m4">{{ commandi + 1 }}</i>
                              <i v-if="
                                  commandi <
                                  inputs.newfunction.commands.length - 1
                              " @click="
                                  inputs.newfunction.commands.splice(
                                    commandi + 1,
                                    0,
                                    inputs.newfunction.commands.splice(
                                      commandi,
                                      1
                                    )[0]
                                  )
                                  " class="fa fa-arrow-down fa-xs r8"></i>

                              <div class="flex align-center wrap">
                                <b @click="
                                    $set(
                                      show,
                                      'command.method' + commandi + 'config',
                                      !show[
                                        'command.method' + commandi + 'config'
                                      ]
                                    )
                                  " :class="!command.method && 'warn label'" class="lg-font r8">{{
                                    command.method || "Undefined command"
                                  }}</b>
                              </div>
                            </div>
                            <div class="flex flexy wrap align-center">
                              <span>
                                (
                                <i class="m4 sm-font" v-for="(a, ai) in command.inputs" :key="ai">{{ ai }}
                                  <b>{{
                                    a.value == "static"
                                      ? ":" + a.static
                                      : ": " + a.value
                                  }}</b>,
                                </i>
                                )
                              </span>
                            </div>
                            <div v-if="
                                show['command.method' + commandi + 'config']
                            ">
                              <div class="
                                  sm-font
                                  flex
                                  align-center
                                  p4
                                  between
                                  wrap
                                  m4
                                ">
                                <div class="flex align-center">
                                  <label class="">
                                    <!-- select command type: app, custom, or another saved function  -->
                                    <debug name="command debug" :entry="command" />
                                    <b class="xs-font m4 align-center">Command</b>
                                    <select v-model="command.type">
                                      <option disabled value="">
                                        Select Type
                                      </option>
                                      <option v-for="fntype in [
                                          'app',
                                          'custom',
                                          'smart',
                                          'user function',
                                      ]" :key="fntype" :value="fntype">
                                        {{ fntype }}
                                      </option>
                                    </select>
                                  </label>
                                </div>

                                <!-- Await option for async commands -->
                                <div v-if="commandi > 0 && hasAsyncCommands(commandi)" class="flex align-center m4">
                                  <label class="xs-font">
                                    <b>Await previous async commands:</b>
                                    <iinput 
                                      v-model="command.await" 
                                      :name="'await_' + commandi"
                                      view="input"
                                      :multiselect="true"
                                      :options="getAsyncCommandOptions(commandi)"
                                    />
                                  </label>
                                </div>

                                <div in-app class="flex align-center" appmethodtype v-if="command.type === 'app'">
                                  <!-- Store method type (dispatch/commit) -->
                                  <select required v-model="command.storeMethod"
                                    @change="command.method = command.storeMethod + '.' + (command.actionName || '')">
                                    <option value="">Select Method</option>
                                    <option value="dispatch">dispatch</option>
                                    <option value="commit">commit</option>
                                  </select>

                                  <!-- Action/Mutation name -->
                                  <select required v-if="command.storeMethod" v-model="command.actionName" @change="
                                    command.method = command.storeMethod + '.' + command.actionName;
                                  setnewfunction(commandi, command.storeMethod, command.actionName)
                                    ">
                                    <option value="">Select {{ command.storeMethod === 'dispatch' ? 'Action' :
                                      'Mutation' }}</option>
                                    <template v-if="command.storeMethod === 'dispatch'">
                                      <option v-for="(func, funcname) in storeActions.dispatch"
                                        :key="funcname" :value="funcname">
                                        {{ funcname }}
                                      </option>
                                    </template>
                                    <template v-if="command.storeMethod === 'commit'">
                                      <option v-for="(func, funcname) in storeActions.commit" :key="funcname"
                                        :value="funcname">
                                        {{ funcname }}
                                      </option>
                                    </template>
                                    </select>

                                  <!-- Type selector for actions with types -->
                                  <select required v-if="
                                    command.storeMethod === 'dispatch' &&
                                    command.actionName &&
                                    storeActions.dispatch[command.actionName] &&
                                    storeActions.dispatch[command.actionName].types
                                  " v-model="command.actionType" @change="
                                      setnewfunction(commandi, command.storeMethod, command.actionName, command.actionType)
                                      ">
                                    <option value="">Select Type</option>
                                    <option v-for="(t, tk) in storeActions.dispatch[command.actionName].types"
                                      :key="tk" :value="tk">
                                        {{ tk }}
                                      </option>
                                    </select>
                                  </div>

                                <!-- User function selection -->
                                <div user-function class="flex align-center" v-if="command.type === 'user function'">
                                  <select required v-model="command.method">
                                    <option value="">Select User Function</option>
                                    <option v-for="(func, funcId) in functions" :key="funcId"
                                      :value="funcId">
                                      {{ func.name || funcId }}
                                    </option>
                                  </select>
                                </div>

                                <div customfunction v-if="command.type === 'custom'" class="flex column">
                                  <!-- Filter input -->
                                  <label class="flex align-center">
                                    <b class="p4">Filter</b>
                                    <input 
                                      class="xs-input" 
                                      type="text" 
                                      v-model="command.customFilter"
                                      placeholder="Filter functions or methods..."
                                      @input="onCustomFilterChange(commandi)"
                                    />
                                  </label>
                                  
                                  <!-- Function vs Method choice -->
                                  <label class="flex align-center">
                                    <b class="p4">Type</b>
                                    <select v-model="command.customType" @change="onCustomTypeChange(commandi)">
                                      <option value="">Select Type</option>
                                      <option value="function">Function</option>
                                      <option value="method">Method</option>
                                    </select>
                                  </label>
                                  
                                  <!-- Function dropdown -->
                                  <div v-if="command.customType === 'function'" class="flex column m4">
                                    <label class="flex align-center">
                                  <b class="p4">Function</b>
                                      <select v-model="command.customFunction" @change="onCustomFunctionChange(commandi, command.customFunction)">
                                        <option value="">Select Function</option>
                                        <option v-for="option in getFilteredDirectFunctions(command.customFilter)" :key="option.value" :value="option.value">
                                          {{ option.label }}
                                        </option>
                                      </select>
                                    </label>
                                    
                                    <!-- Function arguments -->
                                    <div v-if="command.customFunction" class="flex column m4">
                                      <label class="flex align-center">
                                        <b class="p4">Arguments</b>
                                        <iinput 
                                          v-model="command.customArgs" 
                                          :name="`custom_args_${commandi}`"
                                          view="input"
                                          placeholder="Function arguments (comma separated)"
                                        />
                                      </label>
                                    </div>
                                  </div>
                                  
                                  <!-- Method dropdown -->
                                  <div v-if="command.customType === 'method'" class="flex column m4">
                                    <label class="flex align-center">
                                      <b class="p4">Method</b>
                                      <select v-model="command.customMethod" @change="onCustomMethodChange(commandi, command.customMethod)">
                                        <option value="">Select Method</option>
                                        <option v-for="option in getFilteredMethods(command.customFilter)" :key="option.value" :value="option.value">
                                          {{ option.label }}
                                        </option>
                                      </select>
                                    </label>
                                    
                                    <!-- Method arguments -->
                                    <div v-if="command.customMethod" class="flex column m4">
                                      <div v-for="(arg, argIndex) in getCustomMethodArgs(command.customMethod)" :key="argIndex" class="flex align-center m2">
                                        <label class="xs-font">{{ arg.name || `arg${argIndex}` }}:</label>
                                        <iinput 
                                          v-model="command.customMethodArgs[argIndex]" 
                                          :name="`custom_arg_${commandi}_${argIndex}`"
                                          view="input"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <!-- Final method display -->
                                  <label class="flex align-center m4">
                                    <b class="p4">Method</b>
                                  <input
                                    class="xs-input"
                                    type="text"
                                    v-model="command.method"
                                      placeholder="Generated method call" 
                                      readonly
                                  />
                                </label>
                                </div>

                                <!-- Smart contract function selection -->
                                <div smart-contract class="flex column" v-if="command.type === 'smart'">
                                  <label class="flex align-center">
                                    <b class="p4">Contract</b>
                                    <select required v-model="command.smartContract" @change="onSmartContractChange(commandi, command.smartContract)">
                                      <option value="">Select Smart Contract</option>
                                      <option v-for="(contract, contractId) in smartContracts" :key="contractId"
                                        :value="contractId">
                                        {{ contract.name || contractId }}
                                      </option>
                                    </select>
                                  </label>
                                  
                                    <div v-if="command.smartContract && smartContracts[command.smartContract]" class="flex column m4">
                                    <label class="flex align-center">
                                      <b class="p4">Function</b>
                                      <select required v-model="command.smartFunction" @change="onSmartFunctionChange(commandi)">
                                        <option value="">Select Function</option>
                                        <option v-for="func in getSmartContractFunctions(command.smartContract)" :key="func.name"
                                          :value="func.name">
                                          {{ func.name }}({{ func.inputs.map(i => i.type).join(', ') }})
                                        </option>
                                      </select>
                                    </label>
                                    
                                    <div v-if="command.smartFunction" class="p4">
                                      <b>Network:</b>
                                      <select v-model="command.smartNetwork" class="xs-input m4">
                                        <option value="">Select Network</option>
                                        <option v-for="(deployment, network) in smartContracts[command.smartContract].deployments" :key="network"
                                          :value="network">
                                          {{ network }} ({{ deployment ? deployment.address : '' }})
                                        </option>
                                      </select>
                                    </div>
                                    
                                    <label class="flex align-center m4">
                                      <b class="p4">Method</b>
                                      <input
                                        class="xs-input"
                                        type="text"
                                        v-model="command.method"
                                        placeholder="smart.contract.function" 
                                        readonly
                                      />
                                    </label>
                                  </div>
                                </div>
                                <label class="flex align-start column">
                                  <div class="xs-font">Command comment <a href       s>ai drop in</a></div>
                                  <textarea placeholder="Command comment" type="text" v-model="command.comment" />
                                </label>
                              </div>
                              <div list-args class="flex column container p4 m4 indicate">
                                <!-- configure custom function arguments -->
                                <div customarguments class="xs-font flexy">
                                  <b class="flex align-center">Arguments</b>
                                </div>
                                <div class="
                                    flex
                                    between
                                    align-center
                                    container
                                    sm-font
                                    border-bottom
                                  " :style="'order: ' + input.order" v-for="(input, inputkey) in command.inputs"
                                  :key="inputkey">
                                  <div class="flex align-center p4">
                                    <div class="indicate-text flex align-center">
                                      <!-- assign inputs to args -->
                                      <b class="indicate-text p4">{{
                                        inputkey
                                      }}</b>
                                      <!-- set arg type -->
                                      <select v-model="input.type" class="l4">
                                        <option :selected="input.type" :value="opt" v-for="opt in [
                                            'string',
                                            'number',
                                            'boolean',
                                            'array',
                                            'object',
                                            'function',
                                        ]" :key="opt">
                                          {{ opt }}
                                        </option>
                                      </select>
                                    </div>
                                    <span class="flex align-center wrap l4 r4">
                                      <i class="m4 fa fa-arrow-left"></i>
                                      <select class="m4" v-model="input.value">
                                        <!-- type checks before assignment -->
                                        <option :disabled="fninput.type !== input.type
                                          " :value="fninputkey" class="update-text" v-for="(
                                            fninput, fninputkey
                                          ) in inputs.newfunction.inputs" :key="fninputkey">
                                          {{ fninputkey }} [{{ fninput.type }}]
                                        </option>
                                        <option :value="'state.outputs[' +
                                            stateoutputkey +
                                            ']'
                                          " class="update-text" v-for="(
                                            stateoutput, stateoutputkey
                                          ) in (inputs[
                                            'newfunction'
                                          ].state.outputs || []).filter(
                                            (x, i) => i < commandi
                                              )" :key="stateoutputkey">
                                          {{ stateoutputkey + 1 }}
                                          {{
                                            inputs["newfunction"].commands[
                                              stateoutputkey
                                            ].method
                                          }}
                                        </option>
                                        <option value="static">
                                          Static argument
                                        </option>
                                      </select>

                                      <!-- Static argument -->
                                      <div v-if="input.value === 'static'">
                                        <iinput v-model="input.static" :name="commandi + inputkey + 'static'"
                                          :view="input.type === 'string' ? 'input' : input.type === 'number' ? 'input' : input.type === 'boolean' ? 'input' : input.type === 'array' ? 'json' : input.type === 'object' ? 'json' : 'json'" />
                                      </div>

                                      <!-- following allows for deep targeting of an object or array -->
                                      <i v-if="
                                        input.value &&
                                          input.value.includes &&
                                          input.value.includes('state.outputs')
                                      " class="fa fa-bullseye m4 indicate-text" @click="
                                          $set(
                                            show,
                                            commandi + inputkey + 'target',
                                            !show[
                                              commandi + inputkey + 'target'
                                            ]
                                          )
                                          " />
                                      <iinput class="v-scroll" :name="commandi + inputkey + 'target'" v-if="
                                          show[commandi + inputkey + 'target']
                                      " v-model="input.target" view="input" />
                                    </span>
                                  </div>

                                  <!-- set arg order -->
                                  <div class="flex align-center around">
                                    <span class="flex align-center">
                                      <i @click="
                                          $set(input, 'order', input.order - 1)
                                        " class="fa fa-arrow-up fa-sm"></i>
                                      {{ input.order }}
                                      <i @click="
                                          $set(input, 'order', input.order + 1)
                                        " class="fa fa-arrow-down fa-sm"></i>
                                    </span>
                                    <rm :name="inputkey" :obj="command.inputs" />
                                  </div>
                                </div>
                                <div v-if="show[commandi + 'addargument']" class="
                                    flex
                                    align-center
                                    between
                                    container
                                    p4
                                    border-bottom
                                    b4
                                  ">
                                  <input type="text" v-model="inputs[commandi + 'newargname']"
                                    placeholder="Argument name" />
                                  <select argumenttypes v-model="inputs[commandi + 'newargtype']">
                                    <option :value="opt" v-for="opt in [
                                        'string',
                                        'number',
                                        'boolean',
                                        'array',
                                        'object',
                                        'function',
                                    ]" :key="opt">
                                      {{ opt }}
                                    </option>
                                  </select>
                                  <button type="button" :disabled="!(
                                        inputs[commandi + 'newargtype'] &&
                                        inputs[commandi + 'newargname']
                                      )
                                    " class="
                                      fa fa-plus fa-sm
                                      indicate
                                      p4
                                      flex
                                      align-center
                                    " @click="
                                      $set(
                                        inputs.newfunction.commands[commandi]
                                          .inputs,
                                        inputs[commandi + 'newargname'],
                                        {
                                          value: '',
                                          type: inputs[commandi + 'newargtype'],
                                          order: Object.keys(command.inputs)
                                            .length,
                                          static: inputs[commandi + 'newargtype'] === 'string' ? '' :
                                            inputs[commandi + 'newargtype'] === 'number' ? 0 :
                                              inputs[commandi + 'newargtype'] === 'boolean' ? false :
                                                inputs[commandi + 'newargtype'] === 'array' ? [] :
                                                  inputs[commandi + 'newargtype'] === 'object' ? {} : ''
                                        }
                                      );
                                      $set(inputs, commandi + 'newargtype', '');
                                      $set(inputs, commandi + 'newargname', '');
                                      $set(
                                        show,
                                        commandi + 'addargument',
                                        false
                                      );
                                    " />
                                </div>
                              </div>
                              <div class="m4">
                                <button type="button" class="indicate-text xs-font b8" @click="
                                    $set(
                                      show,
                                      commandi + 'addargument',
                                      !show[commandi + 'addargument']
                                    )
                                  ">
                                  <i class="fa fa-plus fa-xs r4"></i> Add
                                  argument
                                </button>
                              </div>

                              <!-- tests take a precongigured set of inputs and expected output, checks to match. other work already surpasses this in the hashtable commit -->
                              <div test class="
                                  xs-font
                                  container
                                  p4
                                  flex
                                  between
                                  wrap
                                  flexy
                                  t4
                                  update
                                  m4
                                ">
                                <b class="" @click="
                                    $set(
                                      show,
                                      'test' + commandi,
                                      !show['test' + commandi]
                                    )
                                  ">Test</b>
                                <div v-if="show['test' + commandi]" class="p4 container" style="align-self: flex-start">
                                  <!-- WHere was I? adding input options (manual entry, state select, function) to test functions. If a function is selected, then recur. Functions must take functions dammit i'm not a doctor, i'm a mornamns -->

                                  <div class="">
                                    <!-- TODO switch assign for iinputs or viceversa -->
                                    <assign :key="inputkey" v-for="(
                                        input, inputkey
                                      ) in command.inputs" :input="input" :inputkey="inputkey" :test="test" />
                                    {{ test }}
                                    <button type="button" @click="runtest(command, test, commandi)"
                                      class="light warn-text xs-font m4">
                                      Test
                                    </button>
                                  </div>
                                  <div v-if="testresult[commandi]">
                                    <div class="flex wrap xs-font between">
                                      <b>Results</b>
                                      <i :class="((Array.isArray(
                                            testresult[commandi]
                                          ) &&
                                            'array') ||
                                            typeof testresult[commandi]) ===
                                          inputs.newfunction.state.outputs[
                                            commandi
                                          ].type
                                            ? 'success-text'
                                            : 'warn-text'
                                        ">Type check:
                                        {{
                                          (Array.isArray(
                                            testresult[commandi]
                                          ) &&
                                            "array") ||
                                          typeof testresult[commandi]
                                        }}</i>
                                      <button class="success" type="button" @click="
                                          $set(command, 'tests', [
                                            test,
                                            testresult[commandi],
                                          ]);
                                          (test = {}),
                                            $delete(testresult, commandi);
                                      ">
                                        Save Test
                                      </button>
                                    </div>
                                    <code class="flex wrap column container p4" style="
                                        max-height: 300px;
                                        overflow: scroll;
                                        max-width: 300px;
                                      ">{{ testresult[commandi] }}</code>
                                  </div>
                                </div>
                              </div>
                              <rm class="self-end fit p4" :name="commandi" :obj="inputs.newfunction.commands" />
                            </div>
                          </div>
                          <div class="flex between">
                            <button class="xs-font align-center success-text" type="button" @click="
                                $set(
                                  show,
                                  'command.method' +
                                    inputs.newfunction.commands.length +
                                    'config',
                                  true
                                );
                                inputs.newfunction.commands.push({
                                  method: '',
                                  inputs: {},
                                  type: '',
                                  tests: [],
                              await: [],
                                });
                            ">
                              <i class="fa fa-plus r4" /> Add command
                            </button>
                            <button class="
                                update
                                m4
                                p8
                                sm-font
                                flex
                                align-center
                                flex-end
                              " text="Save" :disabled="!(
                                  inputs.newfunction &&
                                  inputs.newfunction.name &&
                                  inputs.newfunction.commands[0].method
                                )
                                " type="button" @click="
                                // Check for duplicate function names
                                if ($store.state.ref.functions[inputs.newfunction.name] &&
                                $store.state.ref.functions[inputs.newfunction.name] !== inputs.newfunctionid) {
                                alert('Function name ' + inputs.newfunction.name + ' already exists. Please choose a different name.');
                                return;
                              }

                                !$store.state.app.advanced.functions
                        ? ($store.state.app.advanced.functions = {})
                        : null;
                      $store
                        .dispatch('util', {
                          type: 'hash',
                          body: inputs.newfunction,
                        })
                        .then((h) => {
                                    // Set functionhash property for content tracking
                                    $set(inputs.newfunction, 'functionhash', h);
                                    
                                    // Use existing ID if available, otherwise generate new one
                                    const functionId = inputs.newfunctionid || h;
                                    
                          $set(
                            $store.state.app.advanced.functions,
                                      functionId,
                            inputs.newfunction
                          );
                                    
                                    // Remove old function if ID changed
                                    if (inputs.newfunctionid && inputs.newfunctionid !== functionId) {
                                      $delete($store.state.app.advanced.functions, inputs.newfunctionid);
                                    }
                                    
                                    $set(inputs, 'newfunctionid', functionId);
                                    $set(show, 'customfunction' + functionId, true);

                                    // Update function reference mapping
                                    $set($store.state.ref.functions, inputs.newfunction.name, functionId);

                          $store
                            .dispatch('update', {
                              type: 'app',
                              data: $store.state.app,
                            })
                            .then(() => {
                              $set(
                                counters,
                                inputs.newfunction.name + 'action',
                                counters[
                                  inputs.newfunction.name + 'action'
                                ] + 1
                              );
                            });
                        });
                                ">
                              <div><i class="fa fa-save" /> Save</div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <code v-if="$store.state.debug">{{
                        JSON.stringify(inputs["newfunction"], null, 2)
                      }}</code>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    functions() {
      // Use store functions directly, not introspect data
      return this.$store.state.app.advanced.functions || {};
    },
    smartContracts() {
      return this.$store.state.app.advanced.smartcontracts || {};
    },
    storeActions() {
      // Use introspect data from store state
      const introspection = this.$store.state.agent?.introspection;
      if (introspection && introspection.dispatchActions) {
        const dispatch = {};
        const commit = {};
        
        introspection.dispatchActions.forEach(action => {
          // Parse action name to get module and action name
          const [moduleName, actionName] = action.name.includes('/') 
            ? action.name.split('/') 
            : [null, action.name];
          
          // Only process root actions (no module prefix)
          if (!moduleName) {
            dispatch[actionName] = {
              payload: action.payloadParam ? { [action.payloadParam]: {} } : {},
              types: action.types || {},
              payloadProperties: action.payloadProperties || {}
            };
          }
        });
        
        // Handle mutations from introspect data
        if (introspection.mutations) {
          introspection.mutations.forEach(mutation => {
            // Parse mutation name to get module and mutation name
            const [moduleName, mutationName] = mutation.name.includes('/') 
              ? mutation.name.split('/') 
              : [null, mutation.name];
            
            // Only process root mutations (no module prefix)
            if (!moduleName) {
              commit[mutationName] = {
                payload: mutation.payloadParam ? { [mutation.payloadParam]: {} } : {},
                types: mutation.types || {},
                payloadProperties: mutation.payloadProperties || {}
              };
            }
          });
        }
        
        return { dispatch, commit };
      }
      // Fallback to store data if introspect isn't available
      return { 
        dispatch: this.$store.state.functions?.dispatch || {}, 
        commit: this.$store.state.functions?.commit || {} 
      };
    }
  },
  data() {
    return {
      counters: {},
      debug: this.$store.state.debug,
      inputs: {},
      models: {
        function: {
          name: "",
          inputs: {},
          commands: [
            {
              method: "",
              inputs: {},
              type: "",
              tests: [],
            },
          ],
          output: {},
          test: ["inputs", "return value"],
          show: {},
          state: { outputs: [] }, // For holding output data
        },
      },
      testresult: {},
      show: {},
      test: {},
      introspectionData: null,
    };
  },
  mounted() {
    // Initialize existing commands with proper storeMethod and actionName
    this.initializeExistingCommands();
    
    // Call introspect to get current function data with async flags
    this.$store.dispatch('agent/introspect').then(introspection => {
      console.log('Introspect data loaded:', introspection);
      this.introspectionData = introspection;
    }).catch(error => {
      console.error('Failed to load introspect data:', error);
    });
  },
  watch: {
    // Watch for when functions are loaded/changed for editing
    functions: {
      handler() {
        if (this.inputs && this.inputs.newfunction && this.inputs.newfunction.commands) {
          this.initializeExistingCommands();
        }
      },
      deep: true
    },
    'inputs.newfunction.commands': {
      handler(commands) {
        if (commands) {
          this.initializeExistingCommands();
        }
      },
      deep: true
    }
  },
  methods: {
    initializeExistingCommands() {
      if (this.inputs && this.inputs.newfunction && this.inputs.newfunction.commands) {
        this.inputs.newfunction.commands.forEach(command => {
          if (command.type === 'app' && command.method && command.method.includes('.') && !command.storeMethod) {
            const [storeMethod, actionName] = command.method.split('.');
            this.$set(command, 'storeMethod', storeMethod);
            this.$set(command, 'actionName', actionName);
          }
        });
      }
    },
    getDefaultValueForType(type) {
      switch (type) {
        case 'string': return '';
        case 'number': return 0;
        case 'boolean': return false;
        case 'array': return [];
        case 'object': return {};
        default: return '';
      }
    },
    exportfunction(fn) {
      this.$store.dispatch("export", fn);
    },
    setnewfunction(commandi, functiontype, name, type) {
      this.inputs.newfunction.commands[commandi].inputs = {};
      
      // Get introspection data
      const introspection = this.$store.state.agent?.introspection;
      if (!introspection) {
        console.warn('No introspection data available');
        return;
      }
      
      // Find the action or mutation in introspection data
      let actionData = null;
      if (functiontype === 'dispatch') {
        actionData = introspection.dispatchActions?.find(action => 
          action.name === `${functiontype}.${name}` || action.action === name
        );
      } else if (functiontype === 'commit') {
        actionData = introspection.mutations?.find(mutation => 
          mutation.name === `${functiontype}.${name}` || mutation.mutation === name
        );
      }
      
      if (!actionData) {
        console.warn(`${functiontype} ${name} not found in introspection data`);
        return;
      }
      
      let typesobject = {};
      
      // Use introspection data to populate types
      if (actionData.types && actionData.types[type]) {
        // Action has specific type with payload structure - use the actual payload properties
        typesobject = actionData.types[type];
      } else if (actionData.types && !type) {
        // Action has types but no type selected yet - show generic payload
        typesobject = { [actionData.payloadParam || 'payload']: {} };
      } else if (actionData.payloadProperties) {
        // Action has payload properties from introspection
        typesobject = actionData.payloadProperties;
      } else if (actionData.payloadParam) {
        // Action has a single payload parameter
        typesobject = { [actionData.payloadParam]: {} };
      }
      
      let command = this.inputs.newfunction.commands[commandi];
      
      // Set command inputs based on introspection data
      this.$set(
        this.inputs.newfunction.commands[commandi],
        "inputs",
        command.type == "app"
          ? {
              type,
              ...typesobject,
            }
          : {}
      );

      // method name is function call denoted by [type.method], i.e. dispatch.api or mutation.set
      this.$set(
        this.inputs.newfunction.commands[commandi],
        "method",
        functiontype + "." + name
      );

      // sets up output object for command
      this.$set(this.inputs.newfunction.state.outputs, commandi, {
        type: "",
        value: "",
      });

      // maps config inputs to command inputs
      command.inputs = {};
      if (
        Object.entries(this.inputs.newfunction.inputs).length > 0 &&
        commandi > 0
      ) {
        confirm("Remove function inputs?")
          ? (this.inputs.newfunction.inputs = {})
          : null;
      } else {
        this.inputs.newfunction.inputs = {};
      }
      
      // Process each property from typesobject
      Object.keys(typesobject).map((x, i) => {
        // INFER CORRECT TYPE FIRST - before any matching
        let thistype = this.inferCorrectType(x, actionData, introspection);
        
        // Parse complex argument structures into individual properties
        const parsedProperties = this.parseComplexArgument(x, typesobject[x]);
        
        // If we have parsed properties, create arguments for each
        if (parsedProperties.length > 0) {
          parsedProperties.forEach((prop, propIndex) => {
            const propName = prop.name;
            const propType = prop.type;
            
            // Create function input with high-level type
            const inputType = this.getHighLevelType(propType, null);
            this.$set(this.inputs.newfunction.inputs, propName, { type: inputType });
            this.$set(this.inputs.newfunction.commands[commandi].inputs, propName, {
              order: i + propIndex,
              type: inputType,
              value: propName,
            });
            
            // Create command argument with detailed type
            const hasMatchingInput = this.inputs.newfunction.inputs && this.inputs.newfunction.inputs[propName];
            const defaultValue = hasMatchingInput ? propName : (command.type == "app" ? "static" : "");
            
            this.$set(command.inputs, propName, {
              order: i + propIndex + 1,
              static: this.getDefaultValueForType(propType),
              value: defaultValue,
              type: propType,
              properties: prop.properties || {},
              description: prop.description || ''
            });
          });
        } else {
          // Single property - use original logic
          this.createSingleArgument(x, thistype, i, command, commandi, actionData);
        }
      });
      
      // Special case for app functions that expect a static type
      if (command.type === "app" && actionData.types && actionData.types[type]) {
        this.$set(command.inputs, "type", {
          order: Object.keys(typesobject).length + 1,
          static: type,
          value: "static",
          type: "string",
        });
      }
    },
    // Infer correct type BEFORE any matching
    inferCorrectType(propertyName, actionData, introspection) {
      // First try to infer from models
      if (introspection.models) {
        const modelType = this.inferTypeFromModels(propertyName, introspection.models);
        if (modelType !== 'string') {
          return modelType;
        }
      }
      
      // Try to infer from components
      if (introspection.components) {
        const componentType = this.inferTypeFromComponents(propertyName, introspection.components);
        if (componentType !== 'string') {
          return componentType;
        }
      }
      
      // Use detailed type information from payload properties if available
      if (actionData.payloadProperties && actionData.payloadProperties[propertyName]) {
        const propInfo = actionData.payloadProperties[propertyName];
        if (propInfo.type) {
          return propInfo.type;
        }
      }
      
      // Analyze the property name for patterns
      if (propertyName.includes('.')) {
        // Nested property - likely an object
        return 'object';
      }
      
      if (propertyName.includes('[') && propertyName.includes(']')) {
        // Array-like property
        return 'array';
      }
      
      // Check for generic payload parameter
      if (propertyName === 'payload' || propertyName === 'data') {
        // Generic payload/data parameter - likely an object
        return 'object';
      }
      
      // Default fallback
      return 'string';
    },
    // Parse complex argument structures into individual properties
    parseComplexArgument(propertyName, propertyValue) {
      const parsed = [];
      
      // Check if this looks like a complex object structure
      if (typeof propertyValue === 'string' && propertyValue.includes('{') && propertyValue.includes('}')) {
        // Try to parse object-like structures
        if (propertyValue.includes('keys:') && propertyValue.includes('val:')) {
          // Structure like { keys: ['show', x], val: views[x] }
          parsed.push({
            name: 'keys',
            type: 'array',
            properties: {},
            description: 'Array of keys'
          });
          parsed.push({
            name: 'val',
            type: 'any',
            properties: {},
            description: 'Value to set'
          });
        } else if (propertyValue.includes('key:') && propertyValue.includes('val:')) {
          // Structure like { key: 'someKey', val: someValue }
          parsed.push({
            name: 'key',
            type: 'string',
            properties: {},
            description: 'Key name'
          });
          parsed.push({
            name: 'val',
            type: 'any',
            properties: {},
            description: 'Value to set'
          });
        }
      }
      
      // Also check the property name for complex patterns
      if (propertyName.includes('{') && propertyName.includes('}')) {
        // Property name itself contains complex structure
        if (propertyName.includes('keys:') && propertyName.includes('val:')) {
          parsed.push({
            name: 'keys',
            type: 'array',
            properties: {},
            description: 'Array of keys'
          });
          parsed.push({
            name: 'val',
            type: 'any',
            properties: {},
            description: 'Value to set'
          });
        }
      }
      
      // If no complex structure found, return empty array (will use single property logic)
      return parsed;
    },
    // Create single argument (original logic)
    createSingleArgument(propertyName, propertyType, index, command, commandi, actionData) {
      // Create function input with high-level type
      const inputType = this.getHighLevelType(propertyType, actionData.payloadProperties?.[propertyName]);
      this.$set(this.inputs.newfunction.inputs, propertyName, { type: inputType });
      this.$set(this.inputs.newfunction.commands[commandi].inputs, propertyName, {
        order: index,
        type: inputType,
        value: propertyName,
      });
      
      // Create command argument with detailed type
      const hasMatchingInput = this.inputs.newfunction.inputs && this.inputs.newfunction.inputs[propertyName];
      const defaultValue = hasMatchingInput ? propertyName : (command.type == "app" ? "static" : "");
      
      this.$set(command.inputs, propertyName, {
        order: index + 1,
        static: this.getDefaultValueForType(propertyType),
        value: defaultValue,
        type: propertyType,
        properties: actionData.payloadProperties?.[propertyName]?.properties || {},
        description: actionData.payloadProperties?.[propertyName]?.description || ''
      });
    },
    // Get high-level type for function inputs
    getHighLevelType(detailedType, propInfo) {
      // For function inputs, use high-level types
      if (detailedType === 'object' && propInfo && propInfo.properties) {
        // If it's an object with properties, keep it as object for inputs
        return 'object';
      } else if (detailedType === 'array') {
        return 'array';
      } else if (detailedType === 'boolean') {
        return 'boolean';
      } else if (detailedType === 'number') {
        return 'number';
      } else {
        return 'string'; // Default to string for inputs
      }
    },
    // Get detailed type for command arguments
    getDetailedArgumentType(detailedType, propInfo) {
      // For arguments, use the most specific type available
      if (propInfo && propInfo.type) {
        return propInfo.type;
      }
      
      // Fall back to the detailed type
      return detailedType || 'string';
    },
    // Get detailed type information for arguments
    getDetailedTypeInfo(propertyPath, models) {
      if (!propertyPath || !models) return { type: 'string', properties: {} };
      
      const pathParts = propertyPath.split('.');
      let currentModel = models;
      
      for (const part of pathParts) {
        if (currentModel && typeof currentModel === 'object' && currentModel[part]) {
          currentModel = currentModel[part];
        } else {
          // Try to find partial matches or array patterns
          if (currentModel && typeof currentModel === 'object') {
            const arrayKeys = Object.keys(currentModel).filter(key => key.startsWith('[') && key.endsWith(']'));
            if (arrayKeys.length > 0) {
              const arrayKey = arrayKeys[0];
              const arrayModel = currentModel[arrayKey];
              if (arrayModel && typeof arrayModel === 'object') {
                currentModel = arrayModel;
                continue;
              }
            }
          }
          return { type: 'string', properties: {} };
        }
      }
      
      if (currentModel && typeof currentModel === 'object') {
        const properties = {};
        Object.keys(currentModel).forEach(key => {
          if (typeof currentModel[key] === 'function') {
            properties[key] = { type: currentModel[key].name.toLowerCase() };
          } else if (typeof currentModel[key] === 'object' && currentModel[key] !== null) {
            if (currentModel[key].arrayMap) {
              properties[key] = { type: 'array', description: currentModel[key].arrayMap };
            } else {
              properties[key] = { type: 'object', properties: this.getDetailedTypeInfo(key, { [key]: currentModel[key] }).properties };
            }
          } else {
            properties[key] = { type: typeof currentModel[key] };
          }
        });
        
        return {
          type: Object.keys(properties).length > 0 ? 'object' : 'string',
          properties: properties
        };
      }
      
      return { type: 'string', properties: {} };
    },
    // Helper to infer type from models
    inferTypeFromModels(propertyPath, models) {
      if (!propertyPath || !models) return 'string';
      
      // Handle nested properties with dot notation
      const pathParts = propertyPath.split('.');
      let currentModel = models;
      
      for (const part of pathParts) {
        if (currentModel && typeof currentModel === 'object' && currentModel[part]) {
          currentModel = currentModel[part];
        } else {
          return 'string'; // Default fallback
        }
      }
      
      // If we found a model definition, infer the type
      if (currentModel && typeof currentModel === 'function') {
        return currentModel.name.toLowerCase();
      } else if (currentModel && typeof currentModel === 'object') {
        // Check if it's an array
        if (currentModel.arrayMap) {
          return 'array';
        }
        // Check if it's a boolean
        if (typeof currentModel === 'boolean') {
          return 'boolean';
        }
        // Check if it's a number
        if (typeof currentModel === 'number') {
          return 'number';
        }
        // Default to object for complex structures
        return 'object';
      }
      
      return 'string';
    },
    // Helper to infer type from components
    inferTypeFromComponents(propertyPath, components) {
      if (!propertyPath || !components) return 'string';
      
      // Look for component props that might match this property
      for (const [, component] of Object.entries(components)) {
        if (component && component.props) {
          for (const [propName, propDef] of Object.entries(component.props)) {
            if (propName === propertyPath || propName.includes(propertyPath)) {
              if (propDef && propDef.type) {
                return propDef.type.name ? propDef.type.name.toLowerCase() : 'string';
              }
            }
          }
        }
      }
      
      return 'string';
    },
    runtest(command, test, i) {
      let method = command.method.split(".")[0];
      let type = command.method.split(".")[1];
      command.type === "app" &&
        this.$store[method](type, test).then((d) =>
          this.$set(this.testresult, i, d)
        );
    },
    savetest() { },
    hasAsyncCommands(commandi) {
      // Check if any previous commands are async
      for (let i = 0; i < commandi; i++) {
        const cmd = this.inputs.newfunction.commands[i];
        if (this.isCommandAsync(cmd)) {
          return true;
        }
      }
      return false;
    },
    getAsyncCommandOptions(commandi) {
      // Return array of previous async command indices
      const options = [];
      for (let i = 0; i < commandi; i++) {
        const cmd = this.inputs.newfunction.commands[i];
        if (this.isCommandAsync(cmd)) {
          options.push({
            value: i,
            label: `${i + 1}. ${cmd.method || 'Unnamed command'}`
          });
        }
      }
      return options;
    },
    isCommandAsync(command) {
      // Check if a command is async based on its method
      if (!command.method) return false;
      
      // Dispatch actions are typically async
      if (command.method.startsWith('dispatch.')) {
        return true;
      }
      
      // User functions might be async - check introspect data
      if (command.type === 'user function' && command.method) {
        // Check if we have introspection data
        if (this.introspectionData && this.introspectionData.functions && this.introspectionData.functions[command.method]) {
          return this.introspectionData.functions[command.method].async;
        }
        
        // Fallback to direct function check
        const funcId = this.$store.state.ref.functions[command.method] || command.method;
        const func = this.functions[funcId];
        return func && func.async;
      }
      
      return false;
    },
      scanWindowFunctions() {
        // Dynamic scanning approach - safely scan window object
        const directFunctions = [];
        const constructorFunctions = [];
        
        // Safe scanning approach - only check if properties exist and are functions
        const safeScan = (obj, objName = '') => {
          try {
            const props = Object.getOwnPropertyNames(obj);
            props.forEach(propName => {
              try {
                const prop = obj[propName];
                
                // Skip problematic properties that cause "Illegal invocation" errors
                if (propName === 'constructor' || propName === 'prototype' || 
                    propName === 'length' || propName === 'name' || 
                    typeof prop !== 'function' ||
                    propName.includes('Stream') || propName.includes('Transition') ||
                    propName.includes('FontFace') || propName.includes('InstallPrompt') ||
                    propName.includes('Animation') || propName.includes('GPU') ||
                    propName.includes('ImageDecoder') || propName.includes('ImageTrack') ||
                    propName.includes('MediaKey') || propName.includes('WebTransport') ||
                    propName.includes('ServiceWorker') || propName.includes('Presentation') ||
                    propName.includes('BackgroundFetch') || propName.includes('WebSocket')) {
                  return;
                }
                
                // Check if it's a constructor function (has prototype)
                if (prop.prototype && typeof prop.prototype === 'object') {
                  const methods = [];
                  
                  // Safely get prototype methods
                  try {
                    const prototypeProps = Object.getOwnPropertyNames(prop.prototype);
                    prototypeProps.forEach(methodName => {
                      try {
                        if (methodName !== 'constructor' && 
                            typeof prop.prototype[methodName] === 'function') {
                          methods.push({
                            name: methodName,
                            description: `${propName}.${methodName}()`,
                            type: 'prototype'
                          });
                        }
                      } catch (e) {
                        // Skip problematic methods
                      }
                    });
                  } catch (e) {
                    // Skip if prototype access fails
                  }
                  
                  // Safely get static methods
                  try {
                    const staticProps = Object.getOwnPropertyNames(prop);
                    staticProps.forEach(methodName => {
                      try {
                        if (methodName !== 'prototype' && 
                            methodName !== 'length' && 
                            methodName !== 'name' && 
                            typeof prop[methodName] === 'function') {
                          methods.push({
                            name: methodName,
                            description: `${propName}.${methodName}()`,
                            type: 'static'
                          });
                        }
                      } catch (e) {
                        // Skip problematic static methods
                      }
                    });
                  } catch (e) {
                    // Skip if static method access fails
                  }
                  
                  if (methods.length > 0) {
                    constructorFunctions.push({
                      name: propName,
                      description: `${propName}()`,
                      methods: methods,
                      type: 'constructor'
                    });
                  }
                } else {
                  // Direct function
                  const fullName = objName ? `${objName}.${propName}` : propName;
                  directFunctions.push({
                    name: fullName,
                    description: `${fullName}()`,
                    type: objName ? 'nested' : 'direct'
                  });
                }
              } catch (e) {
                // Skip problematic properties
              }
            });
          } catch (e) {
            // Skip if object scanning fails
          }
        };
        
        // Scan window object
        safeScan(window);
        
        // Scan nested objects
        const nestedObjects = ['console', 'Math', 'JSON', 'Promise'];
        nestedObjects.forEach(objName => {
          try {
            const obj = window[objName];
            if (obj && typeof obj === 'object') {
              safeScan(obj, objName);
            }
          } catch (e) {
            // Skip problematic nested objects
          }
        });
        
        return {
          direct: directFunctions,
          constructors: constructorFunctions
        };
      },
    getFilteredDirectFunctions(filter = '') {
      const windowFunctions = this.scanWindowFunctions();
      return windowFunctions.direct.filter(func => 
        !filter || func.name.toLowerCase().includes(filter.toLowerCase()) || 
        func.description.toLowerCase().includes(filter.toLowerCase())
      ).map(func => ({
        value: func.name,
        label: func.description
      }));
    },
    getFilteredMethods(filter = '') {
      const windowFunctions = this.scanWindowFunctions();
      const allMethods = [];
      
      // Collect all methods from all constructors
      windowFunctions.constructors.forEach(constructor => {
        constructor.methods.forEach(method => {
          allMethods.push({
            value: `${constructor.name}.${method.name}`,
            label: method.description,
            constructor: constructor.name,
            method: method.name
          });
        });
      });
      
      return allMethods.filter(method => 
        !filter || method.label.toLowerCase().includes(filter.toLowerCase()) ||
        method.constructor.toLowerCase().includes(filter.toLowerCase()) ||
        method.method.toLowerCase().includes(filter.toLowerCase())
      );
    },
    getCustomMethodArgs(funcName, methodName) {
      // For now, return a generic argument structure
      // In a real implementation, you'd parse the function signature
      const commonArgs = {
        'map': [{ name: 'callback', type: 'function' }],
        'filter': [{ name: 'callback', type: 'function' }],
        'reduce': [{ name: 'callback', type: 'function' }, { name: 'initialValue', type: 'any' }],
        'forEach': [{ name: 'callback', type: 'function' }],
        'keys': [],
        'values': [],
        'entries': [],
        'toString': [],
        'valueOf': []
      };
      
      return commonArgs[methodName] || [{ name: 'arg', type: 'any' }];
    },
    onCustomFilterChange() {
      // Filter change doesn't need to do anything special
    },
    onCustomTypeChange(commandIndex) {
      const command = this.inputs.newfunction.commands[commandIndex];
      // Clear previous selections when type changes
      this.$set(command, 'customFunction', '');
      this.$set(command, 'customMethod', '');
      this.$set(command, 'customArgs', '');
      this.$set(command, 'customMethodArgs', []);
      this.$set(command, 'method', '');
    },
    onCustomFunctionChange(commandIndex, funcName) {
      const command = this.inputs.newfunction.commands[commandIndex];
      if (funcName) {
        this.$set(command, 'customArgs', '');
        this.$set(command, 'method', funcName);
      }
    },
    onCustomMethodChange(commandIndex, methodValue) {
      const command = this.inputs.newfunction.commands[commandIndex];
      if (methodValue) {
        const [constructor, method] = methodValue.split('.');
        const args = this.getCustomMethodArgs(method);
        this.$set(command, 'customMethodArgs', new Array(args.length).fill(''));
        
        // Set the method call - for static methods like Object.keys(), don't inject arg
        if (method === 'keys' || method === 'values' || method === 'entries' || 
            method === 'assign' || method === 'create' || method === 'freeze' || 
            method === 'seal' || method === 'from' || method === 'isArray' || 
            method === 'of' || method === 'isNaN' || method === 'isFinite' || 
            method === 'isInteger' || method === 'parseInt' || method === 'parseFloat' ||
            method === 'now' || method === 'parse' || method === 'UTC') {
          // Static methods - call directly
          this.$set(command, 'method', `${constructor}.${method}()`);
        } else {
          // Instance methods - call on the input argument
          this.$set(command, 'method', `arg.${method}()`);
        }
      }
    },
    onSmartContractChange(commandIndex) {
      const command = this.inputs.newfunction.commands[commandIndex];
      this.$set(command, 'smartFunction', '');
      this.$set(command, 'smartNetwork', '');
      this.$set(command, 'method', '');
    },
    onSmartFunctionChange(commandIndex) {
      const command = this.inputs.newfunction.commands[commandIndex];
      if (command.smartContract && command.smartFunction) {
        this.$set(command, 'method', `smart.${command.smartContract}.${command.smartFunction}`);
      }
    },
    getSmartContractFunctions(contractId) {
      const contract = this.smartContracts[contractId];
      if (!contract || !contract.abi) return [];
      
      return contract.abi.filter(item => item.type === 'function');
    },
    getSmartContractNetworks(contractId) {
      const contract = this.smartContracts[contractId];
      if (!contract || !contract.deployments) return [];
      
      return Object.keys(contract.deployments);
    },
  },
};
</script>